module.exports = __webpack_public_path__ + "img/电梯动画9.f63f7106.png";